import * as React from "react";
import { toast } from 'react-toastify';
import {useState, useEffect} from 'react';
import {useUploadSiteFileMutation, useDeleteSiteFileMutation} from '../../slices/sitesApiSlice';
import { Form, Row, Col} from 'react-bootstrap'
import 'react-photo-view/dist/react-photo-view.css';
import { PhotoProvider, PhotoView } from 'react-photo-view';


const SitePhotos = (filesite) => {
    const [uploadSiteFile, {isLoading, error}] = useUploadSiteFileMutation();
    const [deleteSiteFile] = useDeleteSiteFileMutation();
    
    const [images, setImages] = useState(filesite.filesite.images);
    const [site, setSite] = useState(filesite.filesite);
  
    const [seed, setSeed] = useState(1);
    const reset = () => {
         setSeed(Math.random());
     }

    useEffect(() => {
        if(filesite.filesite){
            setImages(filesite.filesite.images);
        }
    }, [filesite.filesite])

    const deleteImage = async (index) => {
        const currImage = images[index];
        removeImage(currImage);
    }

    const removeImage = async (image) => {
        const res = await deleteSiteFile({"image":image, "site":site}).unwrap();
        setImages(res.updatedImages);
        window.location.reload();
        reset();
    }

 
    const uploadFileHandler = async (e) => {
        const formData = new FormData();
        for (let i = 0; i < e.target.files.length; i++) {
            formData.append('files', e.target.files[i]);
          }
        formData.append('siteID', filesite.filesite._id);
        formData.append('fileType', "images");
        try{
            const res = await uploadSiteFile(formData).unwrap();
            toast.success(res.message);
            const uploadFiles = [];
            for(let i = 0; i< res.files.length; i++){
                let newFile = {
                    name: res.files[i].name,
                    path: res.files[i].path,
                    thumbnail: res.files[i].thumbnail
                }
                uploadFiles.push(newFile);
            }
            setImages([...images, ...uploadFiles])
        }catch (error){
            toast.error(error?.data?.message || error.error);
        }
    }


    return   isLoading ? (
        <h2>Loading</h2>
    ): error ? (
        <div>{error?.data?.message || error.error}</div>
    ) : (
        <>
        <Row>
            <Col>
                <Form>
                    <Form.Group controlId='file' className='my-2'>
                        <Form.Control type='file' multiple label='Choose Image(s)' onChange={uploadFileHandler}></Form.Control>
                    </Form.Group>
                </Form>
            </Col>
        </Row>
   
        <Row>

        <PhotoProvider key={seed}
            toolbarRender={({onScale, scale, onRotate, rotate, index, onClose}) => {
                return (
                    <>
                         <svg width="22" height="22" fill="red" class="bi bi-trash" viewBox="0 0 16 16" onClick={() => deleteImage(index)}>
                            <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z"></path>
                            <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z"></path>
                        </svg>
                         <svg className="PhotoView-Slider__toolbarIcon" onClick={() => onScale(scale + 1)} width="44" height="44" viewBox="0 0 768 768" fill="white" >
                            <path d="M384 640.5q105 0 180.75-75.75t75.75-180.75-75.75-180.75-180.75-75.75-180.75 75.75-75.75 180.75 75.75 180.75 180.75 75.75zM384 64.5q132 0 225.75 93.75t93.75 225.75-93.75 225.75-225.75 93.75-225.75-93.75-93.75-225.75 93.75-225.75 225.75-93.75zM415.5 223.5v129h129v63h-129v129h-63v-129h-129v-63h129v-129h63z"></path>
                         </svg>
                         <svg className="PhotoView-Slider__toolbarIcon" onClick={() => onScale(scale - 1)} width="44" height="44" viewBox="0 0 768 768" fill="white" >
                            <path d="M384 640.5q105 0 180.75-75.75t75.75-180.75-75.75-180.75-180.75-75.75-180.75 75.75-75.75 180.75 75.75 180.75 180.75 75.75zM384 64.5q132 0 225.75 93.75t93.75 225.75-93.75 225.75-225.75 93.75-225.75-93.75-93.75-225.75 93.75-225.75 225.75-93.75zM223.5 352.5h321v63h-321v-63z"></path>
                        </svg>
                         <svg className="PhotoView-Slider__toolbarIcon" onClick={() => onRotate(rotate + 90)} width="44" height="44" viewBox="0 0 768 768" fill="white">
                            <path d="M565.5 202.5l75-75v225h-225l103.5-103.5c-34.5-34.5-82.5-57-135-57-106.5 0-192 85.5-192 192s85.5 192 192 192c84 0 156-52.5 181.5-127.5h66c-28.5 111-127.5 192-247.5 192-141 0-255-115.5-255-256.5s114-256.5 255-256.5c70.5 0 135 28.5 181.5 75z"></path>
                        </svg>
                    </>
                )
            }}>
            <div className="foo">
                {images.map((image, index) => (
                <PhotoView key={index} src={image.path}>
                    <img src={image.thumbnail} alt=""  style={{maxWidth:'400px',maxHeight:'200px', objectFit: 'cover'}}/>
                </PhotoView>
                ))}
            </div>
        </PhotoProvider>

            
            
        </Row>
        </>
      );
}


export default SitePhotos;